import { render, staticRenderFns } from "./CryptoWallets.vue?vue&type=template&id=4a905970"
import script from "./CryptoWallets.vue?vue&type=script&lang=js"
export * from "./CryptoWallets.vue?vue&type=script&lang=js"
import style0 from "./CryptoWallets.vue?vue&type=style&index=0&id=4a905970&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports